import { useQuery } from '@tanstack/react-query';

import { getTargetedCreatives } from '../api/ventura/contract';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

// The CONTRACT-nested targeted_creatives index opts into the per-domain flip via
// apiHostFor('contractReports') — ACH serves this route as of ACH-r8vb. Same gating as
// useContractCampaigns: now in ACH_MIGRATED_DOMAINS, so it follows the env gate. Its
// only consumer reads the `collection` array
// (ContractTargetedCreatives.tsx:33), not the pagination meta.
function useContractTargetedCreatives(contractId: number) {
  const { apiHostFor } = useConfig();
  const contractReportsHost = apiHostFor('contractReports');

  const query = useQuery({
    queryKey: ['contractTargetedCreatives', contractId],
    queryFn: () => getTargetedCreatives(contractReportsHost, contractId),
    select: camelCaseKeys
  });

  return query;
}

export default useContractTargetedCreatives;
